import './App.css';
import SessionPassPage from './SessionPassPage';

function App() {
    return (
        <div className="App">
            <SessionPassPage />
        </div>
    );
}

export default App;
